<div [ngClass]="modalSize">
    <div class="d-flex flex-column justify-content-start">
        <h4>{{title}}</h4>
        <ng-container *ngIf="text">
            <div [innerHTML]="text" class="mt-2"></div>
        </ng-container>
        <ng-container *ngIf="form">
            <app-basic-form [form]="form" [keys]="formKeys"></app-basic-form>
        </ng-container>
        <ng-container *ngIf="tableKeys && tableValues">
            <ng-container *ngIf="tableValues.length > 0; else emptyTableTemplate">
                <app-basic-table class="w-100" [dataset]="tableValues" [tableKeys]="tableKeys" (actionRequested)="onActionRequested($event)"></app-basic-table>
            </ng-container>
            <ng-template #emptyTableTemplate>
                <div class="mt-4 d-flex text-center flex-column align-items-center p-5">
                    <mat-icon class="no-results-icon">file_copy_off</mat-icon>
                    <h5 class="no-docs-text">Nessun risultato trovato</h5>
                </div>
            </ng-template>
        </ng-container>
    </div>
    <!-- ACTIONS -->
    <div class="d-flex justify-content-between mt-3">
        <ng-container *ngFor="let button of buttons">
            <ng-container *ngIf="button.isRaised; else defaultButtonTemplate">
                <button mat-raised-button [color]="button?.style" [disabled]="isButtonDisabled(button)"
                    (click)="close(button)">
                    {{button?.label}}
                </button>
            </ng-container>
            <ng-template #defaultButtonTemplate>
                <button mat-button [color]="button?.style" [disabled]="isButtonDisabled(button)"
                    (click)="close(button)">
                    {{button?.label}}
                </button>
            </ng-template>
        </ng-container>
    </div>
</div>